import Component from './Component';
import { onScroll, onResizeDebounced } from '../services/ScrollResizeHandler';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
let handleTransition;
let rSRafTimer;
let dSRafTimer;
let OFFSET = 40;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Summary extends Component {

    decorator () {
        return {
            selector : '.js-summary',
            name : 'Summary',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.bindScrolling(window);

        onScroll(this.bindScrolling.bind(this));
    }


    cacheElements () {
        this.$header = document.querySelector('.js-header');
        this.summaryReview = this.element.querySelector('.js-summary-review');
        this.summaryBody = this.element.querySelector('.js-summary-body');
        this.summaryDownload = this.element.querySelector('.js-summary-download');
        this.summaryReviewBoundary = this.summaryReview.getBoundingClientRect();
        this.isSticky = this.summaryReview.classList.contains('is-fixed')
    }


    bindScrolling (scrollObject) {
        this.reviewSticky(scrollObject);
        this.downloadSticky(scrollObject);
    }


    reviewSticky (scrollObject) {
        const offsetTop = this.summaryReviewBoundary.top + this.$header.clientHeight;

        const sticky = () => {
            if (offsetTop - scrollObject.scrollY <= this.summaryReviewBoundary.top - this.$header.clientHeight - OFFSET) {
                if (!this.isSticky) {
                    this.summaryReview.classList.add('is-fixed');
                }
            } else {
                this.summaryReview.classList.remove('is-fixed');
            }
        }

        cancelAnimationFrame(rSRafTimer);

        rSRafTimer = window.requestAnimationFrame(sticky);
    }


    downloadSticky (scrollObject) {
        const offsetTop = this.summaryReviewBoundary.top + this.summaryReviewBoundary.height + this.$header.clientHeight;
        const hitEdge = scrollObject.scrollY <= this.summaryBody.clientHeight - this.summaryBody.offsetTop - this.summaryDownload.clientHeight;

        const sticky = () => {
            if (offsetTop - scrollObject.scrollY <= this.summaryReviewBoundary.top - this.summaryReviewBoundary.height && hitEdge) {
                this.summaryDownload.classList.add('is-show');
            } else {
                this.summaryDownload.classList.remove('is-show');
            }
        }

        cancelAnimationFrame(dSRafTimer);

        dSRafTimer = window.requestAnimationFrame(sticky);
    }


}
